module.exports = __webpack_public_path__ + "img/actualCase-7.4e71302c.jpg";